(function () {
  // ============================================================
  // FREE MASCARA - PLACEHOLDER MODE
  // The free Loungeface Lash is no longer added to the cart. Once a
  // qualifying cart reaches the threshold we only show a message; a
  // Shopify Flow workflow adds the mascara (100% off) to the order
  // after checkout. Nothing in the cart can be charged for the gift,
  // and the half-price mascara offer and discount codes are never
  // affected by it.
  // ============================================================
  var LEGACY_GIFT_VARIANT_ID = 42831941075007;
  var THRESHOLD = 150; // in the customer's currency
  var GIFT_TITLE = 'Loungeface Lash Mascara';
  // Only these brands count toward the threshold. Must match the
  // Flow workflow's qualifying vendors.
  var QUALIFYING_VENDORS = ['Sun Smock', 'Yupieff', 'Loungeface'];
  var _celebrated = false;
  var _debounceTimer;
  var _cleaning = false;
  var CELEBRATED_KEY = 'mascara_unlocked_celebrated';

  function resetCelebration() {
    _celebrated = false;
    try { sessionStorage.removeItem(CELEBRATED_KEY); } catch (e) {}
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // Threshold is 150 in whatever currency the customer is shopping in
  // (AUD 150, USD 150, CAD 150, NZD 150). Must match the Flow workflow.
  function thresholdCents() {
    return THRESHOLD * 100;
  }

  function currencyCode() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    } catch (e) {}
    return 'AUD';
  }

  // A gift line added by the old cart-based version of this script.
  function isLegacyGift(item) {
    return item.variant_id === LEGACY_GIFT_VARIANT_ID &&
      item.properties &&
      item.properties['_gift'] === 'true';
  }

  function isQualifying(item) {
    return QUALIFYING_VENDORS.indexOf(item.vendor) !== -1;
  }

  function qualifyingSubtotal(items) {
    return items.reduce(function (sum, item) {
      if (isLegacyGift(item)) return sum;
      if (!isQualifying(item)) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function hasQualifyingItem(items) {
    for (var i = 0; i < items.length; i++) {
      if (!isLegacyGift(items[i]) && isQualifying(items[i])) return true;
    }
    return false;
  }

  function refreshCartDOM() {
    fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var cartForm = document.getElementById('AjaxCartForm');
        var cartSubtotal = document.getElementById('AjaxCartSubtotal');
        if (cartForm && doc.getElementById('AjaxCartForm')) {
          cartForm.innerHTML = doc.getElementById('AjaxCartForm').innerHTML;
          if (typeof cartForm.ajaxifyCartItems === 'function') cartForm.ajaxifyCartItems();
        }
        if (cartSubtotal && doc.getElementById('AjaxCartSubtotal')) {
          cartSubtotal.innerHTML = doc.getElementById('AjaxCartSubtotal').innerHTML;
        }
        var countEl = cartForm && cartForm.querySelector('[data-cart-count]');
        if (countEl) {
          document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
            el.textContent = countEl.textContent;
          });
        }
      })
      .catch(function () {});
  }

  // Remove any gift line left in a cart from before the switch to
  // placeholder mode, so it can never reach checkout and be charged.
  function removeLegacyGifts(items) {
    var updates = {};
    var found = false;
    items.forEach(function (item) {
      if (isLegacyGift(item)) { updates[item.key] = 0; found = true; }
    });
    if (!found || _cleaning) return Promise.resolve(false);
    _cleaning = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      _cleaning = false;
      refreshCartDOM();
      return true;
    }).catch(function () { _cleaning = false; return false; });
  }

  // ============================================================
  // CONFETTI
  // ============================================================
  // Confetti once per crossing of the threshold, not on every page load.
  function celebrate() {
    if (_celebrated) return;
    _celebrated = true;
    try {
      if (sessionStorage.getItem(CELEBRATED_KEY) === 'true') return;
      sessionStorage.setItem(CELEBRATED_KEY, 'true');
    } catch (e) {}

    var canvas = document.createElement('canvas');
    canvas.style.cssText = [
      'position:fixed','top:0','left:0','width:100%','height:100%',
      'pointer-events:none','z-index:999999'
    ].join(';');
    document.body.appendChild(canvas);

    var W = canvas.width  = window.innerWidth;
    var H = canvas.height = window.innerHeight;
    var ctx = canvas.getContext('2d');

    var COLORS = [
      '#FF3366','#FF6B35','#FFD700','#00E676','#00B0FF',
      '#EA00FF','#FF1744','#FFEA00','#69F0AE','#40C4FF',
      '#E040FB','#FF4081','#CCFF90','#80D8FF','#FF80AB',
      '#ffffff','#ffe57f','#ff6d00'
    ];
    var SHAPES = ['rect','rect','rect','circle','star','ribbon'];
    var pieces = [];
    var OX = W / 2;
    var OY = H * 0.42;

    function randomColor() { return COLORS[Math.floor(Math.random() * COLORS.length)]; }
    function randomBetween(a, b) { return a + Math.random() * (b - a); }

    for (var i = 0; i < 200; i++) {
      var angle = randomBetween(0, Math.PI * 2);
      var speed = randomBetween(6, 22);
      pieces.push({
        x: OX, y: OY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - randomBetween(4, 14),
        r: randomBetween(5, 10), color: randomColor(),
        shape: SHAPES[Math.floor(Math.random() * SHAPES.length)],
        rot: randomBetween(0, Math.PI * 2), rotSpeed: randomBetween(-0.18, 0.18),
        gravity: randomBetween(0.28, 0.55), drag: randomBetween(0.97, 0.995),
        wobble: randomBetween(0, Math.PI * 2), wobbleSpeed: randomBetween(0.05, 0.12),
        alpha: 1, alphaDecay: randomBetween(0.006, 0.014)
      });
    }
    for (var j = 0; j < 60; j++) {
      pieces.push({
        x: randomBetween(0, W), y: randomBetween(-60, -10),
        vx: randomBetween(-1.5, 1.5), vy: randomBetween(1.5, 3.5),
        r: randomBetween(4, 8), color: randomColor(),
        shape: SHAPES[Math.floor(Math.random() * SHAPES.length)],
        rot: randomBetween(0, Math.PI * 2), rotSpeed: randomBetween(-0.08, 0.08),
        gravity: randomBetween(0.04, 0.10), drag: 1,
        wobble: randomBetween(0, Math.PI * 2), wobbleSpeed: randomBetween(0.02, 0.06),
        alpha: 1, alphaDecay: randomBetween(0.003, 0.007)
      });
    }

    function drawStar(ctx, r) {
      var spikes = 5, outerR = r, innerR = r * 0.45, step = Math.PI / spikes;
      ctx.beginPath();
      for (var s = 0; s < spikes * 2; s++) {
        var rad = s % 2 === 0 ? outerR : innerR;
        var a = s * step - Math.PI / 2;
        if (s === 0) ctx.moveTo(Math.cos(a) * rad, Math.sin(a) * rad);
        else ctx.lineTo(Math.cos(a) * rad, Math.sin(a) * rad);
      }
      ctx.closePath();
    }

    var alive = true, frame;
    function tick() {
      ctx.clearRect(0, 0, W, H);
      var anyAlive = false;
      for (var k = 0; k < pieces.length; k++) {
        var p = pieces[k];
        if (p.alpha <= 0) continue;
        anyAlive = true;
        p.wobble += p.wobbleSpeed;
        p.vx *= p.drag;
        p.vy = p.vy * p.drag + p.gravity;
        p.x += p.vx + Math.sin(p.wobble) * 0.8;
        p.y += p.vy;
        p.rot += p.rotSpeed;
        p.alpha -= p.alphaDecay;
        if (p.y > H * 0.85) p.alpha -= 0.025;
        ctx.save();
        ctx.globalAlpha = Math.max(0, p.alpha);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.shape === 'circle') { ctx.beginPath(); ctx.arc(0, 0, p.r, 0, Math.PI * 2); ctx.fill(); }
        else if (p.shape === 'star') { drawStar(ctx, p.r); ctx.fill(); }
        else if (p.shape === 'ribbon') { ctx.fillRect(-p.r * 0.3, -p.r * 1.6, p.r * 0.6, p.r * 3.2); }
        else { ctx.fillRect(-p.r, -p.r * 0.5, p.r * 2, p.r); }
        ctx.restore();
      }
      if (anyAlive && alive) { frame = requestAnimationFrame(tick); } else { canvas.remove(); }
    }
    frame = requestAnimationFrame(tick);
    setTimeout(function () { alive = false; cancelAnimationFrame(frame); canvas.remove(); }, 6000);
  }

  function updateUI(items) {
    var el        = document.getElementById('cart-gift-progress');
    var msg       = document.getElementById('gift-progress-message');
    var bar       = document.getElementById('gift-progress-bar');
    var barWrap   = document.getElementById('gift-progress-bar-wrap');
    var readdWrap = document.getElementById('gift-readd-wrap');
    if (!el) return;

    // No Sun Smock, Yupieff or Loungeface items: hide the module.
    if (!hasQualifyingItem(items)) {
      el.style.display = 'none';
      resetCelebration();
      return;
    }

    el.style.display = 'block';
    if (barWrap) barWrap.style.display = 'block';
    if (readdWrap) readdWrap.style.display = 'none';

    var threshold = thresholdCents();
    var subtotal  = qualifyingSubtotal(items);

    if (subtotal >= threshold) {
      if (bar) bar.style.width = '100%';
      if (msg) msg.innerHTML = '<strong>✓ You\'ve unlocked a free ' + GIFT_TITLE + '!</strong><br>We\'ll add it to your order automatically after checkout.';
      celebrate();
    } else {
      resetCelebration();
      var remaining = threshold - subtotal;
      var amount    = (remaining / 100).toFixed(2);
      var pct       = Math.min(Math.round((subtotal / threshold) * 100), 99);
      if (bar) bar.style.width = pct + '%';
      if (msg) msg.innerHTML = 'Spend <strong>$' + amount + ' ' + currencyCode() + ' more</strong> to receive a free ' + GIFT_TITLE + '.';
    }
  }

  function sync() {
    return getCart().then(function (cart) {
      return removeLegacyGifts(cart.items).then(function (removed) {
        if (removed) return getCart().then(function (c) { updateUI(c.items); });
        updateUI(cart.items);
      });
    }).catch(function () {});
  }

  function debouncedSync() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(sync, 200);
  }

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('cart-updated', debouncedSync);

  var observer = new MutationObserver(debouncedSync);
  function attachObserver() {
    var el = document.getElementById('AjaxCartSubtotal');
    if (el) { observer.observe(el, { childList: true, subtree: true, characterData: true }); }
    else { setTimeout(attachObserver, 500); }
  }
  attachObserver();
})();
